// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".finance-detail .app-dropdown-menu {\n  width: 50px;\n}\n.finance-detail .app-btn-cascader {\n  border: none !important;\n  border-radius: 0px !important;\n}\n.finance-detail .app-btn-cascader-pop {\n  width: 100px;\n  background: red;\n}\n", ""]);
// Exports
module.exports = exports;
